/* eslint-disable */
import { useMutation, useQuery, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IAddresses } from 'src/interfaces/personal-info';
import PersonalInfoService from 'src/services/personal-info.service';

export const useAddAddress = (): UseMutationResult<
  any,
  Error,
  { address: IAddresses; personnelNumber: string },
  void
> =>
  useMutation(
    (data: { address: IAddresses; personnelNumber: string }) =>
      PersonalInfoService.postAddress(data.address, data.personnelNumber),
    {
      onSuccess: () => {
        AlertAdapter('New Address has been added', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useUpdateDependent = (): UseMutationResult<
  any,
  Error,
  { address: IAddresses; personnelNumber: string },
  void
> => {
  return useMutation(
    (data: { address: IAddresses; personnelNumber: string }) =>
      PersonalInfoService.updateAddress(data.address, data.personnelNumber),
    {
      onSuccess: () => {
        AlertAdapter('Your request to Update a address has been successfully submitted.', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
};

export const useDeleteAddress = (): UseMutationResult<void, Error, { address: IAddresses }> => {
  return useMutation(
    ({ address }: { address: IAddresses }) => {
      return PersonalInfoService.deleteAddress(address);
    },
    {
      onSuccess: () => {
        AlertAdapter('Address successfully deleted.', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter('Error deleting address: ' + e.message, 'error');
      },
    }
  );
};
